import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Dashboard = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Obtener el token de la URL
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('jwt'); // Leer el token

    if (token) {
      // Guardar el token en localStorage
      localStorage.setItem('auth_token', token);

      // Redirigir a la ruta protegida
      navigate('/admin', { replace: true });
    } else {
      //console.error('No se recibió ningún token');
      navigate('/login'); // Si no hay token, redirigir al login
    }
  }, [navigate]);

  return <h1>Redirigiendo...</h1>;
};

export default Dashboard;
